
<template id="modal-template"> 
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div v-if="submission != undefined" class="modal-container">

          <div class="modal-header">
            <slot name="header">
                <!-- <span v-if="submission != undefined">Date Received: {{submission.dateInserted}}</span> -->
                <i @click="$emit('cancel')" class="fa fa-arrow-left" aria-hidden="true"></i>
                <i @click="$emit('cancel')" class="fa fa-times" aria-hidden="true"></i>
            </slot>
          </div>

          <div class="modal-body">
            <slot name="body" v-if="submission != undefined">
               
              <div class="submission">
                <img :src="'https://app.brighton.com/summer-of-joy-at-brighton/tmp/900_'+submission.userImage" alt="#mybrightonstyle #brightoncollectibles #summerofjoy #brightonsummerofjoy"/>
                <div class="info">
                  <span class="title">{{submission.firstName}} {{submission.lastName.substring(0,1)}}.</span>
                  <span v-if="submission.city != ''" class="">At {{submission.city}}, {{submission.country}}</span>
                  <span class="">{{submission.pictureLocation}}</span>
                  <!-- <span style="padding-top:10px;">#mybrightonstyle #brightoncollectibles #summerofjoy #brightonsummerofjoy</span> -->
                </div>
              </div>
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              <!-- <button class="modal-default-button" @click="$emit('cancel')">
                Cancel
              </button> -->
              
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>


<script>
const axios = require('axios');
import countries from '../../countries.json'
export default {
    name: 'submissionPopup',
    data () {
      return {
        angle: 0,
        countries: null
      }
    },
    props: {submission: Object},
    computed: {
      imageStyle: function() {
        //
        console.log(this.angle)
        return { transform: 'rotate('+(this.angle)+'deg)' }
      }
    },
    methods:{
      paneImage(degree) {
        this.angle += degree 
        this.angle %= 360
      }
    },
    mounted () {
      this.countries = countries
    }
}
</script>
<style scoped lang="scss">


.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 100%;
  height: 100%;
  box-sizing:border-box;
  overflow-y:scroll;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #f3f3f3;
  background-image: linear-gradient(to bottom, #ececec, #f3f3f3);
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}
.modal-header{
  position:absolute;
  width:100%;
  text-align:left;
  z-index: 3;
  top:0;
  left:0;
  i.fa{
    font-size:25px;
    cursor: pointer;;
  }
  i.fa-arrow-left{
    margin-top:20px;
    margin-left:20px;
  }
  i.fa-times{
    position: absolute;
    top:20px;
    right:20px;
    color:#999;
  }
}
.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  width: 70%;
  margin: 40px auto;
  max-width: 1170px;
  
  .submission{
    background-color:#fff;
    padding:35px;
    border-radius: 5px;
    position:relative;
    box-shadow: rgb(238, 238, 238) 0px 4px 4px;
    .info{
      
      height:100%;
      display:inline-block;
      vertical-align: top;
      width:40%;
      padding:0 25px;
      padding-right:0;
      box-sizing:border-box;
      span{
        display:block;
        line-height:1.3;
        text-align:left;
      }
      span.title{
        font-weight:bold;
        font-size:22px;
      }
    }
    img{
      display:inline-block;
      vertical-align: top;
      max-width: 60%;
      border-radius: 5px;
    }
  }
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}


@media(max-width:768px) {
  .modal-body{
    width:100%;
  }
}
@media(max-width:615px) {
  .modal-body .submission img,
  .modal-body .submission .info {
    display:block;
    width:100%;
    max-width:100%;
  }
  .modal-body .submission .info {
    padding:20px 0;
    font-size:20px;
    span{
      line-height:1.5;

    }
  }
}
</style>